export enum MenuLocation {
    Header = 'header',
    Footer = 'footer',
}
